import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=1d5347e5"
import script from "./preview.ts?vue&type=script&lang=js&external"
export * from "./preview.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports